export class ToggleMoreVideos {
    isOpen: boolean = false;

    toggle(): void {
        this.isOpen = !this.isOpen;
    }

    getChevronIcon(): string {
        return this.isOpen ? svg_icon('icon-chevron-up') : svg_icon('icon-chevron-down');
    }
}
